/**
 * GENERATED by scripts/gen-pack-palettes.mjs — do not edit.
 *
 * theme.json's `colors` / `fonts` preset ids resolved to what the deployed
 * site actually paints, parsed from template-monster's globals.css and
 * lib/fonts.ts. 71 palettes, 33 font pairs, extracted 2026-08-26.
 */

export interface PresetPalette {
  primary: string;
  accent: string;
}

export const PRESET_PALETTES: Record<string, PresetPalette> = {
  "amber-minimal": {
    "primary": "#ffb300",
    "accent": "#fffbeb"
  },
  "aqua": {
    "primary": "#00b3c7",
    "accent": "#ebf3f4"
  },
  "arctic-blue": {
    "primary": "#67b0e4",
    "accent": "#eff3f5"
  },
  "azure-electric": {
    "primary": "#0281c5",
    "accent": "#ebf1f4"
  },
  "blue-classic": {
    "primary": "#092886",
    "accent": "#f5f5f5"
  },
  "brick-red": {
    "primary": "#992929",
    "accent": "#f3ecec"
  },
  "burgundy-deep": {
    "primary": "#8a1e3f",
    "accent": "#f4ecee"
  },
  "burnt-orange": {
    "primary": "#cc4b00",
    "accent": "#f4eeeb"
  },
  "cerulean": {
    "primary": "#007db8",
    "accent": "#ebf1f4"
  },
  "charcoal-minimal": {
    "primary": "#383838",
    "accent": "#f2f2f2"
  },
  "cherry-red": {
    "primary": "#d43535",
    "accent": "#f4ebeb"
  },
  "cobalt": {
    "primary": "#1a49b7",
    "accent": "#eceef4"
  },
  "cobalt-deep": {
    "primary": "#1e42ae",
    "accent": "#ebedf4"
  },
  "cool-steel": {
    "primary": "#5e718d",
    "accent": "#eeeff2"
  },
  "cool-stone": {
    "primary": "#818d9c",
    "accent": "#f1f2f3"
  },
  "coral-energy": {
    "primary": "#ee522b",
    "accent": "#f4edeb"
  },
  "crimson-bold": {
    "primary": "#cf1736",
    "accent": "#f4ebed"
  },
  "denim-blue": {
    "primary": "#3e6da3",
    "accent": "#edeff3"
  },
  "dusty-blue": {
    "primary": "#7e9bb4",
    "accent": "#edf0f2"
  },
  "dusty-violet": {
    "primary": "#8f7ba3",
    "accent": "#f0eef2"
  },
  "electric-blue": {
    "primary": "#1973f0",
    "accent": "#ebeff4"
  },
  "emerald-trust": {
    "primary": "#22a076",
    "accent": "#ebf4f1"
  },
  "forest-green": {
    "primary": "#25935f",
    "accent": "#ebf4f0"
  },
  "fresh-teal": {
    "primary": "#1dafa1",
    "accent": "#ebf4f3"
  },
  "garnet": {
    "primary": "#7d1c2f",
    "accent": "#f3ecee"
  },
  "gold-accent": {
    "primary": "#d39b17",
    "accent": "#f4f1eb"
  },
  "gradient-atomic-fizz": {
    "primary": "#e00b8b",
    "accent": "#f4ebf1"
  },
  "gradient-blue-abyss": {
    "primary": "#0a69e6",
    "accent": "#ebeff4"
  },
  "gradient-earth-matter": {
    "primary": "#2e703b",
    "accent": "#ecf4ed"
  },
  "gradient-forest-machine": {
    "primary": "#247a4e",
    "accent": "#ebf4f0"
  },
  "gradient-neon-clash": {
    "primary": "#0ab6fa",
    "accent": "#ebf2f4"
  },
  "gradient-spiced-bloom": {
    "primary": "#d5781a",
    "accent": "#f4f0eb"
  },
  "gradient-sun-pop": {
    "primary": "#ed511d",
    "accent": "#f4edeb"
  },
  "gradient-velvet-rush": {
    "primary": "#cf3f49",
    "accent": "#f4ebec"
  },
  "gradient-void-spark": {
    "primary": "#00458f",
    "accent": "#ebf0f4"
  },
  "green-classic": {
    "primary": "#448000",
    "accent": "#ecfbda"
  },
  "green-fall": {
    "primary": "#a14d12",
    "accent": "#ec9213"
  },
  "indigo-modern": {
    "primary": "#4236c9",
    "accent": "#ecebf4"
  },
  "midnight-navy": {
    "primary": "#334f8e",
    "accent": "#edeef3"
  },
  "mint-fresh": {
    "primary": "#5ec9a2",
    "accent": "#ecf4f1"
  },
  "moss": {
    "primary": "#5a6f39",
    "accent": "#f0f2ed"
  },
  "mustard": {
    "primary": "#c59e2b",
    "accent": "#f3f2ec"
  },
  "navy-classic": {
    "primary": "#334f8e",
    "accent": "#edeef3"
  },
  "ocean-blue": {
    "primary": "#0073e6",
    "accent": "#ebf0f4"
  },
  "olive": {
    "primary": "#7b883a",
    "accent": "#f2f2ed"
  },
  "orange-classic": {
    "primary": "#f53d00",
    "accent": "#f5f5f5"
  },
  "pacific-blue": {
    "primary": "#0a5999",
    "accent": "#ecf0f4"
  },
  "pine-green": {
    "primary": "#20603e",
    "accent": "#ecf3ef"
  },
  "plum": {
    "primary": "#6b2e5f",
    "accent": "#f2edf1"
  },
  "prussian-navy": {
    "primary": "#1b3555",
    "accent": "#edeff2"
  },
  "pumpkin": {
    "primary": "#e67b1e",
    "accent": "#f4efeb"
  },
  "red-classic": {
    "primary": "#bd0f0f",
    "accent": "#fde3e3"
  },
  "royal-purple": {
    "primary": "#8033cc",
    "accent": "#f0ebf4"
  },
  "rust-red": {
    "primary": "#a44123",
    "accent": "#f3eeec"
  },
  "sage-calm": {
    "primary": "#4b8b6b",
    "accent": "#edf3f0"
  },
  "sage-green": {
    "primary": "#4b8b6b",
    "accent": "#edf3f0"
  },
  "scarlet-hot": {
    "primary": "#dd2c3b",
    "accent": "#f4ebec"
  },
  "seafoam": {
    "primary": "#5ab5a2",
    "accent": "#ecf3f2"
  },
  "sky-light": {
    "primary": "#1f99d6",
    "accent": "#ebf1f4"
  },
  "slate-indigo": {
    "primary": "#4b5a8b",
    "accent": "#edeef2"
  },
  "slate-professional": {
    "primary": "#506286",
    "accent": "#eeeff1"
  },
  "steel-blue": {
    "primary": "#4682b4",
    "accent": "#edf0f2"
  },
  "sunset-amber": {
    "primary": "#f59f0a",
    "accent": "#f4f1eb"
  },
  "sunset-orange": {
    "primary": "#f97015",
    "accent": "#f4efeb"
  },
  "taupe": {
    "primary": "#806f60",
    "accent": "#f1f0ee"
  },
  "teal-classic": {
    "primary": "#00756d",
    "accent": "#d5e1f1"
  },
  "teal-fresh": {
    "primary": "#1dafa1",
    "accent": "#ebf4f3"
  },
  "warm-charcoal": {
    "primary": "#3f3531",
    "accent": "#f3f2f1"
  },
  "warm-earth": {
    "primary": "#d2592d",
    "accent": "#f4eeeb"
  },
  "warm-terracotta": {
    "primary": "#d2592d",
    "accent": "#f4eeeb"
  },
  "yellow-classic": {
    "primary": "#ffc300",
    "accent": "#e5f2d4"
  }
};

export interface FontPair {
  heading: string;
  body: string;
}

export const FONT_PAIRS: Record<string, FontPair> = {
  "artisan": {
    "heading": "Fraunces",
    "body": "Epilogue"
  },
  "avant-garde": {
    "heading": "Syne",
    "body": "Geist"
  },
  "billboard": {
    "heading": "Anton",
    "body": "Roboto Slab"
  },
  "bold": {
    "heading": "Oswald",
    "body": "Roboto"
  },
  "classic": {
    "heading": "Playfair Display",
    "body": "Source Sans 3"
  },
  "crisp": {
    "heading": "Onest",
    "body": "Geist"
  },
  "design-forward": {
    "heading": "Clash Display",
    "body": "Satoshi"
  },
  "dignified": {
    "heading": "Marcellus",
    "body": "Figtree"
  },
  "dynamic": {
    "heading": "Anybody",
    "body": "Figtree"
  },
  "editorial": {
    "heading": "Instrument Serif",
    "body": "Instrument Sans"
  },
  "elegant": {
    "heading": "Cormorant Garamond",
    "body": "Libre Franklin"
  },
  "expressive": {
    "heading": "Bricolage Grotesque",
    "body": "Public Sans"
  },
  "friendly": {
    "heading": "Nunito",
    "body": "Open Sans"
  },
  "geometric": {
    "heading": "Onest",
    "body": "DM Sans"
  },
  "heritage": {
    "heading": "Archivo Black",
    "body": "Archivo"
  },
  "impact": {
    "heading": "Bebas Neue",
    "body": "Open Sans"
  },
  "industrial": {
    "heading": "Big Shoulders Display",
    "body": "Lexend"
  },
  "magazine": {
    "heading": "Bodoni Moda",
    "body": "Outfit"
  },
  "minimal": {
    "heading": "Outfit",
    "body": "Plus Jakarta Sans"
  },
  "modern": {
    "heading": "Inter",
    "body": "Inter"
  },
  "polished": {
    "heading": "Hanken Grotesk",
    "body": "DM Sans"
  },
  "precision": {
    "heading": "Saira Condensed",
    "body": "Saira"
  },
  "professional": {
    "heading": "Montserrat",
    "body": "Lato"
  },
  "readable": {
    "heading": "Merriweather",
    "body": "Source Sans 3"
  },
  "refined": {
    "heading": "DM Serif Display",
    "body": "DM Sans"
  },
  "signature": {
    "heading": "DM Serif Display",
    "body": "Hanken Grotesk"
  },
  "silhouette": {
    "heading": "Bodoni Moda",
    "body": "Plus Jakarta Sans"
  },
  "studio": {
    "heading": "Cabinet Grotesk",
    "body": "General Sans"
  },
  "tactile": {
    "heading": "Bricolage Grotesque",
    "body": "Plus Jakarta Sans"
  },
  "tech": {
    "heading": "Space Grotesk",
    "body": "IBM Plex Sans"
  },
  "tower": {
    "heading": "Anton",
    "body": "Public Sans"
  },
  "utility": {
    "heading": "Barlow Condensed",
    "body": "Barlow"
  },
  "workshop": {
    "heading": "Saira Condensed",
    "body": "Roboto Slab"
  }
};
